import { useEffect } from 'react';
import { useFormikContext } from 'formik';
import { useModalErrors } from './ModalErrorProvider';
const FormikModalErrorSync = ({ errors }) => {
    const formikContext = useFormikContext();
    const { setErrors } = useModalErrors();
    const effectiveErrors = errors ?? formikContext.errors;
    useEffect(() => {
        setErrors(effectiveErrors);
        return () => {
            setErrors(undefined);
        };
    }, [effectiveErrors, setErrors]);
    return null;
};
export default FormikModalErrorSync;
